// Where the game talks to. Empty (same origin) for the normal site; the itch.io build bakes in the address of the real server (build-itch.mjs).
declare const __SERVER__: string;
export const SERVER: string = typeof __SERVER__ === "string" ? __SERVER__.replace(/\/$/, "") : "";
/** URL of an API path ("/api/...") on the game server. */
export const api = (path: string) => SERVER + path;
/** WebSocket address of the game server. */
export const wsUrl = () => (SERVER ? SERVER.replace(/^http/, "ws") + "/ws" : `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/ws`);
